// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2_grc","legacyBtn":"MutateMid_legacyBtn__2OlFt"};